"use client";

import { usePathname, useRouter } from "next/navigation";
import { LayoutList, Ticket } from "lucide-react";
import { SegmentedTabSwitcher, type SegmentedTabItem } from "@aera/ui";

type SupportNavTab = "board" | "mine";

const SUPPORT_NAV_TABS: SegmentedTabItem<SupportNavTab>[] = [
  { id: "board", label: "บอร์ด", icon: LayoutList },
  { id: "mine", label: "ตั๋วของฉัน", icon: Ticket },
];

const SUPPORT_NAV_HREF: Record<SupportNavTab, string> = {
  board: "/support",
  mine: "/support/mine",
};

export function SupportNav({ className = "" }: { className?: string }) {
  const pathname = usePathname();
  const router = useRouter();

  const isMine =
    pathname === "/support/mine" || pathname.startsWith("/support/mine/");
  const activeTab: SupportNavTab = isMine ? "mine" : "board";

  return (
    <nav
      className={`flex flex-nowrap items-center justify-end mb-0 ${className}`.trim()}
      aria-label="เมนูซัพพอร์ต"
    >
      <SegmentedTabSwitcher
        tabs={SUPPORT_NAV_TABS}
        activeTab={activeTab}
        onChange={(id) => {
          const href = SUPPORT_NAV_HREF[id];
          if (href !== pathname) router.push(href);
        }}
        ariaLabel="เมนูซัพพอร์ต"
      />
    </nav>
  );
}
